import React, { useEffect, useState } from 'react';
import ProzoDataGrid from '../../common/ProzoDataGrid';
import { Box, Typography, Chip, Button } from '@mui/material';
import { maskAddress, maskPhoneNumber, parseDateAndTime, shouldMaskDataPD } from '../../helpers/UtilityHelper';
import Loader from '../../common/Loader';
import { useGetNPRDataQuery } from '../../redux/commonRTK';
import { buildFilterConditions } from '../../helpers/UtilityHelper';
import { apiConstants, post } from '../../common/constants';
import { useSnackbar } from "notistack";
import NprAction from './action';
import ConfirmDialog from '../../common/ConfirmDialog';
import { getMerchant } from '../../helpers/ReduxHelpers';
import { useSelector } from 'react-redux';
import jwt_decode from 'jwt-decode';
import { getToken } from '../../helpers/ReduxHelpers';
import { primaryTextSx, secondaryTextSx, awbTextSx, cellStackSx, getStatusChipSx, getPaymentChipSx } from '../orders/list2/cellStyles';
import { FONT, SIZE } from '../../styles/foundation/typography';
import { primaryBtnSx, secondaryBtnSx } from '../../styles/patterns';
import { SUCCESS, ERROR } from '../../styles/foundation/colors';
import AwbLinkCell from '../../common/AwbLinkCell';


const PendingNprData = (props) => {
    const { report } = useSelector(state => state);
    const { piiAccessAllow } = jwt_decode(getToken());
    const [page, setPage] = useState(0);
    const [sizePerPage, setSizePerPage] = useState(10);
    const [pendingNdrData, setPendingNDRData] = useState({});
    const { enqueueSnackbar } = useSnackbar()
    const [currentNDRId, setCurrentNDRId] = useState({});
    const [currentNDRAction, setCurrentNDRAction] = useState();
    const [actionShow, setActionShow] = useState(false);
    const [isExecuting, setIsExecuting] = useState(false);
    const [isLoadingBtn, setIsLoadingBtn] = useState(false);
    const [reload, setReload] = useState(0)
    const [cancelConfirm, setCancelConfirm] = React.useState(false);

    const merchant = getMerchant();
    const merchantId = merchant.id ? merchant.id : ''

    const exclude =
        "terminalStatus,shipmentDetail.cartonItems,invoiceNumber,shipmentType,returnInfo,labelUrl,dispatchMode,giftwrapCharge,transactionCharge,shippingCharge,isInsured,codType,riskType,appointmentDelivery,async,order_date,courierDetail.key,createdDate,actualPickUpTime,lastStatusUpdateTime,epd,edd,order_history,merchantPricing,merchant,orderManifest,invoiceUrl,courierPricingRTO,courierPricing,overriddenCourierAccountCode,actualCourierProviderName,isDiscrepancyRaised,discrepancyId,securityKey,sortCode,channelType,channelName,itemList,createdByUser,skipRule,modifiedByUser,rvp_reason,channel_name,customerDetail,cpErrorList,mongoLabelSignedUrlDetails,overriddenCourierRule,mongoInvoiceSignedUrlDetails,merchant,modifiedByUser,lastModifiedDate,courier";
    const filterConditions = buildFilterConditions(props.filters);
    const { data: pendingData, isLoading, refetch } = useGetNPRDataQuery({
        andfilter: [
            {
                "field": "orderStatus",
                "operator": "in",
                "value": [
                    "PICKUP_FAILED"
                ]
            },
            {
                "field": "is_reverse",
                "operator": "eq",
                "value": true

            },
            {
                "field": "nprData.nprStatus",
                "operator": "in",
                "value": [
                    "REPORTED"
                ]
            },
            { field: "merchant.$id", operator: "eq", value: merchantId },
            ...filterConditions.andfilter
        ],
        orfilter: [...filterConditions.orfilter],
        offset: page * sizePerPage,
        limit: sizePerPage,
        skipCount: true,
        controllerFilter: true,
        excludes: exclude,
    })

    useEffect(() => {
        setPage(0)
    }, [sizePerPage, props.filters])

    useEffect(() => {
        refetch();
    }, [reload, refetch]);


    const columns = [
        {
            field: 'orderdetails', headerAlign: "left", hideSortIcons: true, headerName: 'Order Details', flex: 1, minWidth: 160, renderCell: (params) => {
                const { row } = params;
                return (
                    <Box sx={cellStackSx}>
                        <Typography sx={primaryTextSx}>{row.reference}</Typography>
                        {row.shippingLabelId && row.reference !== row.shippingLabelId && (
                            <Typography sx={secondaryTextSx}>{row.shippingLabelId}</Typography>
                        )}
                        <Typography sx={secondaryTextSx}>
                            {row.awbRegisteredDate ? parseDateAndTime(row.awbRegisteredDate) : ""}
                        </Typography>
                    </Box>
                )
            },
        },
        {
            field: 'courierDetails', headerAlign: "left", hideSortIcons: true, headerName: 'Courier Details', flex: 1, minWidth: 160, renderCell: (params) => {
                const { row } = params;
                return (
                    <Box sx={cellStackSx}>
                        <AwbLinkCell awb={row.awb_number} sx={awbTextSx} />
                        <Typography sx={secondaryTextSx}>{row?.courierDetail?.parent}</Typography>
                    </Box>
                )
            },
        },
        {
            field: 'status', headerAlign: "left", hideSortIcons: true, headerName: 'Status', flex: 0.8, minWidth: 120, renderCell: (params) => {
                const { row } = params;
                return (
                    <Chip size="small" label={row?.nprData?.nprStatus} sx={getStatusChipSx(row?.nprData?.nprStatus)} />
                )
            },
        },
        {
            field: 'pickup_details', headerAlign: "left", hideSortIcons: true, headerName: 'Pickup Address', flex: 1.5, minWidth: 200, renderCell: (params) => {
                const { row } = params;
                return (
                    <Box sx={cellStackSx}>
                        <Typography sx={primaryTextSx}>{row.pickup_details?.from_name}</Typography>
                        <Typography sx={secondaryTextSx}>
                            {shouldMaskDataPD(report, row, piiAccessAllow) ? maskPhoneNumber(
                                row.pickup_details?.from_phone_number
                            ) : (
                                row.pickup_details?.from_phone_number
                            )}
                        </Typography>
                        <Typography sx={secondaryTextSx}>
                            {shouldMaskDataPD(report, row, piiAccessAllow) ? maskAddress(
                                row.pickup_details?.from_address,
                                row.pickup_details?.from_city,
                                row.pickup_details?.from_state,
                                row.pickup_details?.from_pincode
                            ) : (
                                <>
                                    {row.pickup_details?.from_address}
                                    {row.pickup_details?.from_city}
                                    {row.pickup_details?.from_state}
                                    {row.pickup_details?.from_pincode}
                                </>
                            )}
                        </Typography>
                    </Box>
                )
            },
        },
        {
            field: 'nprCpStatusDescription', headerAlign: "left", hideSortIcons: true, headerName: 'NPR Status Description', flex: 1, minWidth: 180, renderCell: (params) => {
                const { row } = params;
                return (
                    <Box sx={cellStackSx}>
                        <Typography sx={secondaryTextSx}>
                            {(row.nprData && row.nprData.nprCpStatusDescription)
                                ? row.nprData.nprCpStatusDescription
                                : (row.nprData && row.nprData.remark)
                                    ? row.nprData.remark
                                    : "-"}
                        </Typography>
                        <Typography sx={secondaryTextSx}>
                            {(row.nprData && row.nprData.nprReportedDate) ? parseDateAndTime(row.nprData.nprReportedDate, true) : ""}
                        </Typography>
                    </Box>
                )
            },
        },
        {
            field: 'ofPCount', headerAlign: "left", hideSortIcons: true, headerName: 'OFP Attempt Count', flex: 0.6, minWidth: 130, renderCell: (params) => {
                const { row } = params;
                return (
                    <Typography sx={secondaryTextSx}>
                        {(row.nprData && row.nprData?.ofPCount) ? `${row.nprData?.ofPCount} attempt(s)` : "0 attempt(s)"}
                    </Typography>
                )
            },
        },
        {
            field: 'paymentDetails', headerAlign: "left", hideSortIcons: true, headerName: 'Payment Details', flex: 0.8, minWidth: 140, renderCell: (params) => {
                const { row } = params;
                const paymentMode = row.payment_mode ? row.payment_mode : '';
                return (
                    <Box sx={cellStackSx}>
                        <Typography sx={primaryTextSx}>
                            {row.invoice_value ? 'Rs. ' + row.invoice_value : '-'}
                        </Typography>
                        <Chip size="small" label={paymentMode} sx={getPaymentChipSx(paymentMode)} />
                    </Box>
                )
            },
        },
        {
            field: 'action', headerAlign: "left", hideSortIcons: true, headerName: 'Action', flex: 1, minWidth: 140, renderCell: (params) => {
                const { row } = params;
                return (
                    <Box sx={{ ...cellStackSx, gap: 0.5 }}>
                        <Button variant="contained" size="small" sx={primaryBtnSx}
                            disabled={row?.nprData?.nprStatus === "CLOSED"}
                            onClick={() => handleActionShow(row, "reattempt")}>Reattempt</Button>
                        <Button variant="outlined" size="small" sx={secondaryBtnSx}
                            disabled={row?.nprData?.nprStatus === "CLOSED"}
                            onClick={() => handleClickCancel(row, "CANCEL_PICKUP")}>Cancel</Button>
                    </Box>
                )
            },
        },
    ];

    useEffect(() => {
        if (pendingData) {
            setPendingNDRData(pendingData);
        }
    }, [pendingData]);


    const handleActionShow = (row, type) => {
        setCurrentNDRId(row);
        setCurrentNDRAction(type);
        setActionShow(true);
    };
    const handleClickCancel = (row, type) => {
        setCurrentNDRId(row);
        setCurrentNDRAction(type);
        setCancelConfirm(true);
    };

    const handleActionClose = () => {
        setActionShow(false);
    };

    const handleReattempt = (data) => {
        const payload = Object.assign(
            {},
            {

                action: "REATTEMPT",
            },
            data
        );

        const param = {
            npr_waybills_data: [payload],
        };
        sendNDRAction(param);
    };
    const handleCancel = () => {
        const payload = Object.assign(
            {},
            {
                action: "CANCEL_PICKUP",
                awb: currentNDRId.awb_number,
            },
        );
        const param = {
            npr_waybills_data: [payload],
        };
        sendNDRAction(param);
    };
    const sendNDRAction = (param) => {
        setIsLoadingBtn(true)
        setIsExecuting(true);
        post(`${apiConstants.BASE_LOCAL}${apiConstants.REATTEMPT_NPR}`, param)
            .then((response) => {
                setIsLoadingBtn(false)
                setIsExecuting(false);
                setCurrentNDRId({});
                setCurrentNDRAction();
                setActionShow(false);
                setReload(reload => reload + 1)
                props.setReload(reload => reload + 1)
                if (response?.data?.meta?.success === true && response.status === 200) {
                    enqueueSnackbar(response.data?.meta?.message || 'Action performed successfully', { variant: 'success' });
                } else {
                    enqueueSnackbar(response.data?.meta?.message, { variant: 'error' });
                }
            })
            .catch((err) => {
                setIsLoadingBtn(false)
                const message = err?.response?.data?.message || err.message;
                if (message === 'Target System Error') {
                    enqueueSnackbar("Please wait a few minutes before you try again", { variant: 'error' });
                }
                else {
                    enqueueSnackbar(err?.response?.data?.message || err.message, { variant: 'error' });
                }
                setIsExecuting(false);
            });
    };

    return (
        <>
            {(isLoading || isExecuting) && <Loader />}
            <ProzoDataGrid columns={columns}
                autoHeight={true}
                rows={(pendingNdrData.data && pendingNdrData.data.length > 0) ? pendingNdrData.data : []}
                sizePerPage={sizePerPage}
                setSizePerPage={setSizePerPage}
                setPage={setPage}
                page={page}
                pagination={true}
                hideFooterPagination={false}
                filterMode={"server"}
                rowCount={Number.MAX_VALUE}
                getRowId={(row) => row.id} />
            <NprAction
                show={actionShow}
                handleClose={handleActionClose}
                currentNDRId={currentNDRId}
                currentNDRAction={currentNDRAction}
                handleReattemp={handleReattempt}
                setReload={setReload}
                isLoadingBtn={isLoadingBtn}
            />
            <ConfirmDialog
                title=''
                open={cancelConfirm}
                setOpen={setCancelConfirm}
                onConfirm={() => handleCancel()}>
                Are you sure you want to Cancel?
            </ConfirmDialog>
        </>
    );
};

export default PendingNprData
